import cookies from './util.cookies';
import log from './util.log';
import db from './util.db';
import Setting from '@/setting';
import { getDictItemByCodes } from '@api/dict';
var util = {
  cookies: cookies,
  log: log,
  db: db
};
export function uuid() {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 32; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23];
  var uuid = s.join("");
  return uuid;
}
function tTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var $t = window ? window.$app.$t : null;
  if ($t) {
    if (title.indexOf('$t:') === 0) {
      return $t(title.split('$t:')[1]);
    } else {
      return title;
    }
  } else {
    return title;
  }
}

/**
 * @description 更改标题
 * @param {Object} title 标题
 * @param {Object} count 未读消息数提示（可视情况选择使用或不使用）
 */
util.title = function (_ref) {
  var title = _ref.title,
    count = _ref.count;
  title = tTitle(title);
  var fullTitle;
  if (Setting.titleSuffix === false || Setting.titleSuffix === '') {
    fullTitle = title ? "".concat(title) : '';
  } else {
    fullTitle = title ? "".concat(title, " - ").concat(Setting.titleSuffix) : Setting.titleSuffix;
  }
  if (count) fullTitle = "(".concat(count, "\u6761\u6D88\u606F)").concat(fullTitle);
  window.document.title = fullTitle;
};
function requestAnimation(task) {
  if ('requestAnimationFrame' in window) {
    return window.requestAnimationFrame(task);
  }
  setTimeout(task, 16);
}
export function hasIntersection(arr1, arr2) {
  var set = new Set(arr1);
  for (var i = 0; i < arr2.length; i++) {
    if (set.has(arr2[i])) {
      return true;
    }
  }
  return false;
}
/**
 * 判断是否为空
 * @param str 字符串
 * @returns 为空返回true
 */
export function isEmpty(str) {
  return str === '' || str === undefined || str === null;
}

/**
 * 判断是否为空
 * @param str 字符串
 * @returns 为空返回true
 */
export function initDictItems(codes, setDict) {
  getDictItemByCodes({
    categoryCodes: codes
  }).then(function (resp) {
    setDict(resp);
  }).catch(function () {}).finally(function () {});
}
export { requestAnimation };
export default util;